import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
ReactModal.setAppElement('#react-app');

class Modal extends Component {

    componentDidUpdate() {
        if (this.props.isOpen) {
            document.querySelector('body').setAttribute('style', 'overflow-y: hidden');
        }
        else {
            document.querySelector('body').setAttribute('style', 'overflow-y: auto');
        }
    }

    render() {

        const {
            children, height, isOpen, width, modalTitle, ...props
        } = this.props;

        const style = {
            content: {
                margin: 'auto',
                width,
                height,
                top: '0',
                left: '0',
                right: '0',
                bottom: '0',
                background: '#e2e8f0',
                borderRadius: '0',
                border: 'none',
            },
            overlay: {
                zIndex: 1001,
                backgroundColor: 'transparent',
            },
        };

        return (
            <ReactModal isOpen={isOpen} style={style} {...props}>
                <div className="xl:tw-container tw-text-center tw-py-10 lg:tw-py-20">
                    <h2 className="font-arapey tw-text-4xl lg:tw-text-5xl tw-font-normal tw-text-gray-700 leading-12">{modalTitle}</h2>
                    {children}
                </div>
            </ReactModal>
        );
    }
}

Modal.defaultProps = {
    isOpen: false,
    onClose: null,
};

Modal.propTypes = {
    children: PropTypes.node,
    height: PropTypes.number,
    isOpen: PropTypes.bool,
    width: PropTypes.number,
    modalTitle: PropTypes.node.isRequired,
    onClose: PropTypes.func
};

export default Modal;
